"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5025],{

/***/ 452882:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ HeaderHome; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);

var HeaderHome = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: props.width || "16.983",
        height: props.height || "16.984",
        viewBox: "0 0 16.983 16.984",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            id: "home",
            fill: props.color || "#000",
            d: "M17.026,7.387h0L10.1.458a1.563,1.563,0,0,0-2.211,0L.961,7.383.954,7.39a1.563,1.563,0,0,0,1.04,2.664l.048,0h.276v5.1a1.832,1.832,0,0,0,1.83,1.83H6.859a.5.5,0,0,0,.5-.5v-4a.836.836,0,0,1,.835-.835h1.6a.836.836,0,0,1,.835.835v4a.5.5,0,0,0,.5.5h2.711a1.832,1.832,0,0,0,1.83-1.83v-5.1h.256a1.564,1.564,0,0,0,1.107-2.669Zm-.7,1.507a.565.565,0,0,1-.4.167h-.754a.5.5,0,0,0-.5.5v5.6a.836.836,0,0,1-.835.835H11.62v-3.5a1.832,1.832,0,0,0-1.83-1.83h-1.6a1.832,1.832,0,0,0-1.83,1.83v3.5H4.148a.836.836,0,0,1-.835-.835v-5.6a.5.5,0,0,0-.5-.5H2.052a.568.568,0,0,1-.391-.97h0L8.589,1.162a.568.568,0,0,1,.8,0l6.926,6.926,0,0A.57.57,0,0,1,16.321,8.894Zm0,0",
            transform: "translate(-0.499)"
        })
    });
};


/***/ }),

/***/ 153987:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(626042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(269396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var _utils_showMegaMenu__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36408);
/* harmony import */ var _utils_checkClientDeviceType__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(313508);
/* harmony import */ var _utils_isPLPRequiredSystem__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(586423);
/* harmony import */ var _utils_emoticonsStatus__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(218626);
/* harmony import */ var _utils_routes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(540190);
/* harmony import */ var _assets_svgExports_SupermarketIcon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(281431);
/* harmony import */ var _assets_svgExports_HeaderInfoIcon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(337247);
/* harmony import */ var _assets_svgExports_HeaderHome__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(452882);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(811163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(667294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(225617);
/* harmony import */ var _utils_getNavList__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(704956);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(913886);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(505152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _assets_svgExports_WishlistHeartIcon__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(407056);
/* eslint new-cap: ["error", { "newIsCap": false }]*/ 

















var MegaMenuMobileView = next_dynamic__WEBPACK_IMPORTED_MODULE_12___default()(function() {
    return __webpack_require__.e(/* import() */ 574).then(__webpack_require__.bind(__webpack_require__, 880574)).then(function(mod) {
        return mod.default;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(880574)
            ];
        }
    },
    ssr: false
});
var NavigationItems = function(param) {
    var _categories = param.categories, categories = _categories === void 0 ? [] : _categories, _horizontalNav = param.horizontalNav, horizontalNav = _horizontalNav === void 0 ? true : _horizontalNav, _navigationItems = param.navigationItems, navigationItems = _navigationItems === void 0 ? [] : _navigationItems, _isFooter = param.isFooter, isFooter = _isFooter === void 0 ? false : _isFooter, _closeNavigationOnMobile = param.closeNavigationOnMobile, closeNavigationOnMobile = _closeNavigationOnMobile === void 0 ? undefined : _closeNavigationOnMobile, _showCategories = param.showCategories, showCategories = _showCategories === void 0 ? false : _showCategories, _headerName = param.headerName, headerName = _headerName === void 0 ? "" : _headerName, toggleMegaMenu = param.toggleMegaMenu;
    var shopMenuRef = (0,react__WEBPACK_IMPORTED_MODULE_8__.useRef)();
    var moreMenuRef = (0,react__WEBPACK_IMPORTED_MODULE_8__.useRef)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)({
        openShop: false,
        openMore: false,
        openMegaMenu: false
    }), open = ref[0], setOpen = ref[1];
    var storeData = (0,react_redux__WEBPACK_IMPORTED_MODULE_9__/* .useSelector */ .v9)(function(state) {
        return {
            storeData: state.storeReducer.store
        };
    }).storeData;
    (0,react__WEBPACK_IMPORTED_MODULE_8__.useEffect)(function() {
        document.addEventListener("mousedown", handleClickOutside);
        return function() {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    var navItemsState = (0,_utils_getNavList__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP)(navigationItems, _utils_constants__WEBPACK_IMPORTED_MODULE_11__/* .MAX_VISIBLE_NAV_LINKS */ .Ow, showCategories);
    var handleClickOutside = function(e) {
        var ref, ref1;
        if (!(shopMenuRef === null || shopMenuRef === void 0 ? void 0 : (ref = shopMenuRef.current) === null || ref === void 0 ? void 0 : ref.contains(e.target))) {
            setOpen(function(state) {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({}, state), {
                    openShop: false
                });
            });
        }
        if (!(moreMenuRef === null || moreMenuRef === void 0 ? void 0 : (ref1 = moreMenuRef.current) === null || ref1 === void 0 ? void 0 : ref1.contains(e.target))) {
            setOpen(function(state) {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({}, state), {
                    openMore: false
                });
            });
        }
    };
    var renderDropdownNav = function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "cfe-dropdown-nav",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "cfe-dropdown-nav__items",
                children: categories.map(function(category) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "cfe-dropdown-nav__item",
                        onClick: function() {
                            return onCategoriesLinkHandle(category);
                        },
                        children: (0,_utils_emoticonsStatus__WEBPACK_IMPORTED_MODULE_16__/* .removeEmoticons */ ._)(category.name) || "Available Items"
                    }, category.id);
                })
            })
        });
    };
    var navSubList = function(nav) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "cfe-dropdown-nav",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "cfe-dropdown-nav__items",
                children: nav.map(function(n) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "cfe-dropdown-nav__item",
                        onClick: function() {
                            return onHandlePageClick(n);
                        },
                        children: n.page_name
                    }, n.page_id);
                })
            })
        });
    };
    var onCategoriesLinkHandle = function(category) {
        var ref;
        if ((0,_utils_isPLPRequiredSystem__WEBPACK_IMPORTED_MODULE_17__/* .isPLPRequiredSystem */ .q)(storeData === null || storeData === void 0 ? void 0 : (ref = storeData.theme) === null || ref === void 0 ? void 0 : ref.theme_class)) {
            var ref1;
            window.location.href = (0,_utils_routes__WEBPACK_IMPORTED_MODULE_3__.getRoute)("".concat(_utils_routes__WEBPACK_IMPORTED_MODULE_3__.PATH.SHOP, "?cid=").concat(category.id), storeData === null || storeData === void 0 ? void 0 : (ref1 = storeData.store_info) === null || ref1 === void 0 ? void 0 : ref1.domain);
        } else {
            var ref2;
            next_router__WEBPACK_IMPORTED_MODULE_7___default().push((0,_utils_routes__WEBPACK_IMPORTED_MODULE_3__.getRoute)("".concat(_utils_routes__WEBPACK_IMPORTED_MODULE_3__.PATH.PRODUCT, "?cid=").concat(category.id), storeData === null || storeData === void 0 ? void 0 : (ref2 = storeData.store_info) === null || ref2 === void 0 ? void 0 : ref2.domain), undefined, {
                shallow: true
            });
        }
        if (open) {
            setOpen(false);
            closeNavigationOnMobile === null || closeNavigationOnMobile === void 0 ? void 0 : closeNavigationOnMobile();
        }
    };
    var handleShopClickForMegaMenu = function() {
        _utils_checkClientDeviceType__WEBPACK_IMPORTED_MODULE_2__/* .IS_DESKTOP */ .yn ? toggleMegaMenu && toggleMegaMenu() : setOpen(function(state) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({}, state), {
                openMegaMenu: !open.openMegaMenu
            });
        });
    };
    var onHandlePageClick = function(nav) {
        _utils_checkClientDeviceType__WEBPACK_IMPORTED_MODULE_2__/* .IS_DESKTOP */ .yn && (0,_utils_showMegaMenu__WEBPACK_IMPORTED_MODULE_1__/* .showMegaMenu */ .G)() && toggleMegaMenu && toggleMegaMenu();
        if (nav.page_type === "blank_page" && nav.is_external_url) {
            window.open(nav.slug_url, "_blank");
            return;
        }
        if (nav.slug_url === "wishlist") {
            var ref;
            next_router__WEBPACK_IMPORTED_MODULE_7___default().push((0,_utils_routes__WEBPACK_IMPORTED_MODULE_3__.getRoute)(_utils_routes__WEBPACK_IMPORTED_MODULE_3__.PATH.WISHLIST, storeData === null || storeData === void 0 ? void 0 : (ref = storeData.store_info) === null || ref === void 0 ? void 0 : ref.domain));
            return;
        }
        if (nav.slug_url === "shop") {
            (0,_utils_showMegaMenu__WEBPACK_IMPORTED_MODULE_1__/* .showMegaMenu */ .G)() && !isFooter ? handleShopClickForMegaMenu() : setOpen(function(state) {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({}, state), {
                    openShop: !open.openShop
                });
            });
        } else if ([
            "more",
            "subNavList"
        ].includes(nav.slug_url)) {
            setOpen(function(state) {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({}, state), {
                    openMore: !open.openMore
                });
            });
        } else {
            if (nav.is_editable) {
                var ref1;
                window.location.href = (0,_utils_routes__WEBPACK_IMPORTED_MODULE_3__.getRoute)(_utils_routes__WEBPACK_IMPORTED_MODULE_3__.PATH.additionalPage(nav.slug_url), storeData === null || storeData === void 0 ? void 0 : (ref1 = storeData.store_info) === null || ref1 === void 0 ? void 0 : ref1.domain);
            } else {
                var ref2;
                next_router__WEBPACK_IMPORTED_MODULE_7___default().push((0,_utils_routes__WEBPACK_IMPORTED_MODULE_3__.getRoute)(nav.slug_url, storeData === null || storeData === void 0 ? void 0 : (ref2 = storeData.store_info) === null || ref2 === void 0 ? void 0 : ref2.domain));
            }
            closeNavigationOnMobile === null || closeNavigationOnMobile === void 0 ? void 0 : closeNavigationOnMobile();
        }
    };
    var renderNavType = function(nav) {
        switch(nav.page_type){
            case "shop":
                {
                    if (headerName !== "Header14") {
                        var ref, ref1;
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                            ref: shopMenuRef,
                            className: "cfeNavItems__item",
                            onClick: function() {
                                return onHandlePageClick(nav);
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "mr3 visible-mobile",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets_svgExports_SupermarketIcon__WEBPACK_IMPORTED_MODULE_4__/* .SupermarketIcon */ .N, {
                                                color: (storeData === null || storeData === void 0 ? void 0 : (ref = storeData.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.colors) === null || ref1 === void 0 ? void 0 : ref1.primary_color) !== "#ffffff" ? "#000000" : "#ffffff",
                                                width: 16,
                                                height: 16
                                            })
                                        }),
                                        nav.page_name,
                                        (categories === null || categories === void 0 ? void 0 : categories.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                            src: "https://cdn.dotpe.in/longtail/themes/8073865/igP6Hh58.webp",
                                            alt: "dropdown button",
                                            style: {
                                                transform: "rotate(".concat(horizontalNav ? "90deg" : "0deg", ")")
                                            }
                                        })
                                    ]
                                }),
                                open.openShop && renderDropdownNav(),
                                open.openMegaMenu && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MegaMenuMobileView, {
                                    open: true,
                                    onClose: function() {
                                        if (open) {
                                            setOpen(false);
                                            closeNavigationOnMobile === null || closeNavigationOnMobile === void 0 ? void 0 : closeNavigationOnMobile();
                                        }
                                    }
                                })
                            ]
                        }, nav.page_id);
                    } else {
                        return null;
                    }
                }
            case "wishlist":
                {
                    var ref2, ref3;
                    return !_utils_checkClientDeviceType__WEBPACK_IMPORTED_MODULE_2__/* .IS_DESKTOP */ .yn && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "cfeNavItems__item",
                        onClick: function() {
                            return onHandlePageClick(nav);
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    style: {
                                        marginRight: 20
                                    },
                                    className: "visible-mobile",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets_svgExports_WishlistHeartIcon__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                        color: (storeData === null || storeData === void 0 ? void 0 : (ref2 = storeData.theme) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.colors) === null || ref3 === void 0 ? void 0 : ref3.primary_color) !== "#ffffff" ? "#000000" : "#ffffff"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    children: nav.page_name
                                })
                            ]
                        })
                    }, nav.page_id);
                }
            case "subNavList":
                {
                    var ref4;
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                        ref: moreMenuRef,
                        className: "cfeNavItems__item cfeNavItem-padding",
                        onClick: function() {
                            return onHandlePageClick(nav);
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                children: [
                                    nav.page_name,
                                    (nav === null || nav === void 0 ? void 0 : (ref4 = nav.subNavs) === null || ref4 === void 0 ? void 0 : ref4.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        alt: "dropdown button",
                                        src: "https://cdn.dotpe.in/longtail/themes/8073865/igP6Hh58.webp",
                                        style: {
                                            transform: "rotate(".concat(horizontalNav ? "90deg" : "0deg", ")")
                                        }
                                    })
                                ]
                            }),
                            open.openMore && navSubList(nav.subNavs)
                        ]
                    }, nav.page_id);
                }
            case "about-us":
                {
                    var ref5, ref6;
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "cfeNavItems__item",
                        onClick: function() {
                            return onHandlePageClick(nav);
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    style: {
                                        marginRight: 20
                                    },
                                    className: "visible-mobile",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets_svgExports_HeaderInfoIcon__WEBPACK_IMPORTED_MODULE_5__/* .HeaderInfoIcon */ .V, {
                                        color: (storeData === null || storeData === void 0 ? void 0 : (ref5 = storeData.theme) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.colors) === null || ref6 === void 0 ? void 0 : ref6.primary_color) !== "#ffffff" ? "#000000" : "#ffffff"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    children: nav.page_name
                                })
                            ]
                        })
                    }, nav.page_id);
                }
            case "home":
                {
                    var ref7, ref8;
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "cfeNavItems__item",
                        onClick: function() {
                            return onHandlePageClick(nav);
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "mr3 visible-mobile",
                                    style: {
                                        marginLeft: -1
                                    },
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets_svgExports_HeaderHome__WEBPACK_IMPORTED_MODULE_6__/* .HeaderHome */ .Q, {
                                        color: (storeData === null || storeData === void 0 ? void 0 : (ref7 = storeData.theme) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.colors) === null || ref8 === void 0 ? void 0 : ref8.primary_color) !== "#ffffff" ? "#000000" : "#ffffff"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    children: nav.page_name
                                })
                            ]
                        })
                    }, nav.page_id);
                }
            case "blank_page":
                {
                    return nav.is_external_url ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "cfeNavItems_item mb3 cfeNavItems-padding cfeNavItems-margin",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            style: {
                                color: "#000000",
                                fontSize: 14
                            },
                            className: "cfeNavItem-padding mr3 link",
                            href: nav.slug_url,
                            target: "_blank",
                            rel: "noreferrer",
                            children: nav.page_name
                        })
                    }, nav.page_id) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "cfeNavItems__item cfeNavItem-padding",
                        onClick: function() {
                            return onHandlePageClick(nav);
                        },
                        children: nav.page_name
                    }, nav.page_id);
                }
            default:
                {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "cfeNavItems__item cfeNavItem-padding",
                        onClick: function() {
                            return onHandlePageClick(nav);
                        },
                        children: nav.page_name
                    }, nav.page_id);
                }
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "cfeNavItems ".concat(horizontalNav ? "" : "vertical-nav", " ").concat(isFooter ? "footer-nav-style" : ""),
        children: navItemsState.map(function(nav) {
            return renderNavType(nav);
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (NavigationItems);


/***/ }),

/***/ 220949:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _checkIfThemePreview__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(115483);
/* harmony import */ var _checkRenderEnv__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(506337);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(913886);
/* harmony import */ var _getUrlParams__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(705492);




var checkIfShowDummyProduts = function(storeData) {
    var isPreview = (0,_checkIfThemePreview__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
    var isPremium = !!storeData.premium;
    var items_available = (!_checkRenderEnv__WEBPACK_IMPORTED_MODULE_1__/* .IS_SERVER */ .W6 && (0,_getUrlParams__WEBPACK_IMPORTED_MODULE_3__/* .getUrlParams */ .D)([
        _constants__WEBPACK_IMPORTED_MODULE_2__/* .PREVIEW_PARAMS.ITEMS_AVAILABLE */ .I.ITEMS_AVAILABLE
    ])).items_available;
    var isItemsAvailable = +items_available;
    return isPreview && (!isPremium || !isItemsAvailable);
};
/* harmony default export */ __webpack_exports__["Z"] = (checkIfShowDummyProduts);


/***/ }),

/***/ 168491:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _checkIfShowDummyProducts__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(220949);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(913886);


/**
 * function to get store logo in case of dummy or actual data
 * @param storeInfo
 * @returns
 */ var getActualOrDsStoreLogo = function(storeInfo) {
    var ref;
    var showDummyData = (0,_checkIfShowDummyProducts__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(storeInfo);
    return (storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.store_info) === null || ref === void 0 ? void 0 : ref.logo_image) || (showDummyData ? _constants__WEBPACK_IMPORTED_MODULE_1__/* .DS_LOGO_IMAGE_URL */ .pP : null);
};
/* harmony default export */ __webpack_exports__["Z"] = (getActualOrDsStoreLogo);


/***/ }),

/***/ 704956:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p6": function() { return /* binding */ showMyAccount; }
/* harmony export */ });
/* unused harmony export isUserLoggedIn */
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(629815);
/* harmony import */ var _checkClientDeviceType__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(313508);
/* harmony import */ var _redux_store__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(167261);
/* harmony import */ var _checkRenderEnv__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(506337);
/* harmony import */ var _routes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(540190);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(913886);






var isUserLoggedIn = function() {
    var ref;
    return !!((ref = _redux_store__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getState */ .Z.getState().userReducer) === null || ref === void 0 ? void 0 : ref.isLogin);
};
var showMyAccount = function() {
    return !_checkRenderEnv__WEBPACK_IMPORTED_MODULE_2__/* .IS_SERVER */ .W6 && _checkClientDeviceType__WEBPACK_IMPORTED_MODULE_0__/* .IS_MOBILE */ .q$ && _checkRenderEnv__WEBPACK_IMPORTED_MODULE_2__/* .IS_WEBVIEW */ .x5 && isUserLoggedIn();
};
var myAccountNavData = {
    page_name: "My Account",
    slug_url: _routes__WEBPACK_IMPORTED_MODULE_3__.PATH.MY_ACCOUNT,
    page_type: "my-account"
};
var getNavList = function(navigationItems) {
    var visibleItemsLength = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _constants__WEBPACK_IMPORTED_MODULE_4__/* .MAX_VISIBLE_NAV_LINKS */ .Ow, showCategories = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var subNavObj = {
        page_type: "subNavList",
        subNavs: [],
        is_editable: false,
        page_id: "616d2bd6152384798123d775",
        page_name: showCategories ? "Categories" : "More",
        slug_url: showCategories ? "more" : "subNavList"
    };
    var showMyAccountSection = showMyAccount();
    if ((navigationItems === null || navigationItems === void 0 ? void 0 : navigationItems.length) > 0) {
        var tempNavList = [];
        if (showCategories) {
            tempNavList = navigationItems.filter(function(nav) {
                return nav.page_type !== "shop";
            });
        } else {
            tempNavList = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(navigationItems);
        }
        if ((navigationItems === null || navigationItems === void 0 ? void 0 : navigationItems.length) > visibleItemsLength) {
            var extractedNavList = tempNavList.splice(visibleItemsLength, tempNavList.length);
            subNavObj.subNavs = extractedNavList;
            if (showMyAccountSection) {
                subNavObj.subNavs.push(myAccountNavData);
            }
            var newNavList = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(tempNavList).concat([
                subNavObj
            ]);
            return newNavList;
        } else {
            if (showMyAccountSection) {
                subNavObj.subNavs.push(myAccountNavData);
                tempNavList.push(subNavObj);
            }
            return tempNavList;
        }
    }
    return [];
};
/* harmony default export */ __webpack_exports__["ZP"] = (getNavList);


/***/ }),

/***/ 273494:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ getVisibilityForFooter; },
/* harmony export */   "g": function() { return /* binding */ getVisibilityForHeader; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(629815);
// the status defines the visibility of logo or name with respect to header and footer

var STATUS_DISABLED = 0;
var STATUS_SHOW_ON_HEADER = 1;
var STATUS_SHOW_ON_FOOTER = 2;
var STATUS_SHOW_ON_HEADER_FOOTER = 3;
// const STATUS_DONT_SHOW_ON_HEADER_FOOTER = 4;
var COMMON_STATUS_SHOW = [
    STATUS_DISABLED,
    STATUS_SHOW_ON_HEADER_FOOTER
];
function getVisibilityForHeader(status) {
    return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(COMMON_STATUS_SHOW).concat([
        STATUS_SHOW_ON_HEADER
    ]).includes(status);
}
function getVisibilityForFooter(status) {
    return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(COMMON_STATUS_SHOW).concat([
        STATUS_SHOW_ON_FOOTER
    ]).includes(status);
}


/***/ })

}]);